<template>
    <div class="width100">

        <vue-confirm-dialog></vue-confirm-dialog>

        <b-modal id="modalInfo" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>

            </template>
            <div class="d-block">
                <div v-if="errors2.length" class="alert alert-danger text-center" role="alert">
                    <p v-for="(error, key) in errors2" :key="key">{{ error }}</p>
                </div>
                <div v-if="msgs2.length" class="alert alert-success text-center" role="alert">
                    <p v-for="(msg, key) in msgs2" :key="key">{{ msg }}</p>
                </div>
            </div>
        </b-modal>

        <b-modal id="modalLastTache" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>

            </template>
            <div class="d-block">
                <div class="alert alert-danger text-center" role="alert">
                    <p v-if="nbrJourLastTache==1000">Merci de faire une {{tache.intitule.toLowerCase()}}, elle n'a jamais été réalisée.</p>
                    <p v-if="nbrJourLastTache!=1000">Merci de faire une {{tache.intitule.toLowerCase()}} la dernière date de {{dateLastTache}}</p>
                </div>
            </div>
        </b-modal>


        <div class="row">
            <div class="col-10  offset-1">

                <div class="row" v-if="tache.niveau==2">
                    <div class="col-4">
                        Durée (minute)
                    </div>
                    <div class="col-8">
                        <input type="number" v-model="duree" class="form-control">
                    </div>
                </div>
                <br/>
                <div v-if="machineType.charge==1" class="row">
                    <div class="col-4">
                        Niveau charge (%)
                    </div>
                    <div class="col-8">
                        <div class="row">
                            <div class="col-12">
                                <select v-model="niveauCharge" class="form-control">
                                    <option value="0"></option>
                                    <option value="20">- de 20%</option>
                                    <option value="40">40%</option>
                                    <option value="60">60%</option>
                                    <option value="80">80%</option>
                                    <option value="100">100%</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div v-if="tache.miseChargNive==1" class="row">
                    <div class="col-4">
                        Mise en charge
                    </div>
                    <div class="col-8">
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-6">
                                        <span style="font-size: 35px" v-if="miseEnCharge==1" @click="miseEnCharge=0">Non
                                        <i class="fa fa-square-o fa-2x" v-if="miseEnCharge==1"
                                           aria-hidden="true"></i>
                                        </span>

                                        <span style="font-size: 35px" class="text-danger" v-if="miseEnCharge==0">Non
                                            <i class="fa fa-check-square-o fa-2x text-danger"
                                               v-if="miseEnCharge==0" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                    <div class="col-6">
                                        <span style="font-size: 35px" v-if="miseEnCharge==0" @click="miseEnCharge=1">Oui
                                        <i class="fa fa-square-o fa-2x" v-if="miseEnCharge==0"
                                           aria-hidden="true"></i>
                                        </span>

                                        <span style="font-size: 35px" class="text-success" v-if="miseEnCharge==1">Oui
                                            <i class="fa fa-check-square-o fa-2x text-success"
                                               v-if="miseEnCharge==1" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div v-if="tache.miseChargNive==2" class="row">
                    <div class="col-4">
                        Mise à niveau
                    </div>
                    <div class="col-8">
                        <div class="row">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-6">
                                        <span style="font-size: 35px" v-if="miseANiveau==1" @click="miseANiveau=0">Non
                                        <i class="fa fa-square-o fa-2x" v-if="miseANiveau==1"
                                           aria-hidden="true"></i>
                                        </span>

                                        <span style="font-size: 35px" class="text-danger" v-if="miseANiveau==0">Non
                                            <i class="fa fa-check-square-o fa-2x text-danger"
                                               v-if="miseANiveau==0" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                    <div class="col-6">
                                        <span style="font-size: 35px" v-if="miseANiveau==0" @click="miseANiveau=1">Oui
                                        <i class="fa fa-square-o fa-2x" v-if="miseANiveau==0"
                                           aria-hidden="true"></i>
                                        </span>

                                        <span style="font-size: 35px" class="text-success" v-if="miseANiveau==1">Oui
                                            <i class="fa fa-check-square-o fa-2x text-success"
                                               v-if="miseANiveau==1" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div v-if="machineType.horametre==1" class="row">
                    <div class="col-4">
                        Horametre
                    </div>
                    <div class="col-7">
                        <input type="number" v-model="horametre" class="form-control">
                    </div>
                </div>
                <div v-if="machineType.horametre==1" class="row">
                    <div class="col-4">
                        Dernier horametre
                    </div>
                    <div class="col-7">
                        <b>{{ lastHorametre }}</b>
                    </div>
                </div>

                <br/>
                <div v-if="machineType.charge!=1 && machineType.horametre!=2" class="row">
                    <div class="col-12 text-center">
                        <h6>Aucune information supplémentaire n'est requise</h6>
                    </div>
                </div>
                <br/>
                <!--<div class="row">
                    <div class="col-12 text-center">
                        <span class="fa-stack fa-lg " @click="$emit('takePicture')">
                            <i class="fa fa-circle fa-stack-2x  text-warning"></i>
                            <i class="fa fa-camera fa-stack-1x fa-inverse"></i>
                        </span>
                    </div>
                </div>-->
                <Picture v-if="ifAppli==1" @returnPicture="returnPicture"></Picture>
                <PictureNav  v-if="ifAppli==0" @returnPictureNav="returnPictureNav"></PictureNav>
                <br/>
                <div class="col-12 text-center">
                    <i v-if="dataUrl2 || image" class="fa-regular fa-trash-can fa-2x text-danger"
                       @click="deletePicture()"></i>
                </div>

                <div class="row" v-if="dataUrl2">
                    <div class="col-12">
                        <p>Cette photo sera jointe à la panne :</p>
                        <b-img :src="dataUrl2" fluid-grow
                               alt="Responsive image"></b-img>
                    </div>
                </div>
                <p v-if='dataUrl2==null && image!=null' v-html="image"></p>
                <br/>
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" block @click="saveOperation()">
                            Valider
                        </button>
                        &nbsp;
                        <button class="btn btn-danger" block @click="returnAMaintenance()">Retour</button>
                        &nbsp;
                        <button v-if='idModif!=null' class="btn btn-danger" block @click="deleteOperation()">Supprimer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Picture from './Picture';
    import PictureNav from './PictureNav';
    const Tesseract = require('tesseract.js');

    export default {
        name: "OperationFormulaire",
        props: ['token', 'site', 'user', 'racine', 'machine', 'tache', 'userId', 'machineType', 'idModif','systemeClient',
            'ifAppli'],
        data() {
            return {
                duree: 0, niveauCharge: 0, horametre: 0, errors2: [], msgs2: [], lastHorametre: 0,
                blob2: null, dataUrl2: null, image: null, miseEnCharge: 0, miseANiveau: 0,
                miseANiveauObligatoire:0,nbrChiffreLastHorametre:0,textImg:'',nbrJourLastTache:0,
                dateLastTache:null
            };
        },
        methods:
            {
                saveOperation() {
                    this.errors2 = [];
                    this.msgs2 = [];
                    const h = this.$createElement
                    var msgConfirm = []
                    if (this.machineType.charge == 1 || this.machineType.horametre == 1 || this.tache.niveau == 2) {
                        msgConfirm.push(h('div', {class: ['foobar']}, [
                            h('p', {class: ['text-center']}, [
                                h('strong', 'Récapitulatif : '),
                            ]),
                        ]))
                    }

                    var valide = true
                    if (this.machineType.charge == 1) {//si chariot
                        if (this.niveauCharge > 0) {
                            msgConfirm.push(h('div', {class: ['foobar']}, [
                                h('p', {class: ['text-center']}, [
                                    "Niveau de charge : " + this.niveauCharge
                                ]),
                            ]))
                        }
                        else {
                            this.errors2.push("Le niveau de charge n'est pas correct.")
                            valide = false
                        }

                        if(this.tache.miseChargNive == 1)
                        {
                            if (this.niveauCharge == 20 && this.miseEnCharge == 0) {
                                this.errors2.push("Vous devriez mettre en charge.")
                                valide = false
                            }
                        }

                        if(this.tache.miseChargNive == 1)
                        {
                            if (this.niveauCharge >= 80 && this.miseEnCharge == 1) {
                                this.errors2.push("Vous ne devriez pas mettre en charge.")
                                valide = false
                            }
                            else
                            {
                                var ouiNonMC = 'Oui'
                                if(this.miseEnCharge == 0)
                                {
                                    ouiNonMC = 'Non'
                                }

                                msgConfirm.push(h('div', {class: ['foobar']}, [
                                    h('p', {class: ['text-center']}, [
                                        "Mise en charge : " + ouiNonMC
                                    ]),
                                ]))

                            }
                        }

                        if(this.tache.miseChargNive == 2)
                        {
                            if (this.miseANiveauObligatoire == 1 && this.miseANiveau == 0) {
                                this.errors2.push("Vous devriez faire les niveaux.")
                                valide = false
                            }
                            else
                            {
                                var ouiNonMN = 'Oui'
                                if(this.miseANiveau == 0)
                                {
                                    ouiNonMN = 'Non'
                                }

                                msgConfirm.push(h('div', {class: ['foobar']}, [
                                    h('p', {class: ['text-center']}, [
                                        "Mise à niveau : " + ouiNonMN
                                    ]),
                                ]))
                            }
                        }
                    }
                    if (this.machineType.horametre == 1) {//si chariot
                        console.log(this.horametre + '>=' + this.lastHorametre)
                        if(this.lastHorametre>0) {
                            if (this.horametre >= this.lastHorametre && this.horametre <= (this.lastHorametre + 30)) {
                                msgConfirm.push(h('div', {class: ['foobar']}, [
                                    h('p', {class: ['text-center']}, [
                                        "Horamètre : " + this.horametre
                                    ]),
                                ]))
                            }
                            else {
                                var msgError2 = ""
                                if (this.horametre < this.lastHorametre) {
                                    msgError2 = "L'horamètre est inférieur à la dernière fois. "
                                    if(this.nbrChiffreLastHorametre != this.digits_count(this.horametre))
                                    {
                                        msgError2 += "Il était sur "+this.nbrChiffreLastHorametre+" chiffres. "
                                    }
                                    this.errors2.push(msgError2)
                                }
                                else if (this.horametre > (this.lastHorametre + 30)) {
                                    msgError2 = "L'horamètre semble trop élevé. "
                                    if(this.nbrChiffreLastHorametre != this.digits_count(this.horametre))
                                    {
                                        msgError2 += "Il était sur "+this.nbrChiffreLastHorametre+" chiffres. "
                                    }
                                    this.errors2.push(msgError2)
                                }
                                valide = false
                            }
                        }
                        else
                        {
                            msgConfirm.push(h('div', {class: ['foobar']}, [
                                h('p', {class: ['text-center']}, [
                                    "Horamètre : " + this.horametre
                                ]),
                            ]))
                        }
                    }

                    if (this.tache.niveau == 2) {
                        if (this.duree > 0) {
                            msgConfirm.push(h('div', {class: ['foobar']}, [
                                h('p', {class: ['text-center']}, [
                                    "Durée : " + this.duree
                                ]),
                            ]))
                        }
                        else {
                            this.errors2.push("La durée n'est pas correcte.")
                            valide = false
                        }
                    }


                    if (valide == true) {
                        console.log(msgConfirm)
                        const messageVNode = msgConfirm
                        this.$bvModal.msgBoxConfirm(messageVNode, {
                            title: 'Confirmation',
                            size: 'lg',
                            buttonSize: 'lg',
                            okVariant: 'danger',
                            okTitle: 'Oui',
                            cancelTitle: 'Non',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            noFade: true
                        })
                            .then(value => {
                                if (value == true) {


                                    var today = new Date()
                                    var month = today.getMonth() + 1
                                    var day = today.getDate()
                                    if (month < 10) {
                                        month = "0" + month
                                    }
                                    if (day < 10) {
                                        day = "0" + day
                                    }
                                    var myHeaders = new Headers();
                                    myHeaders.append("Authorization", "Bearer " + this.token);


                                    var formdata = new FormData()
                                    formdata.append('date', today.getFullYear() + '-' + month + '-' + day)
                                    formdata.append('machine', this.machine['id'])
                                    formdata.append('user', this.userId)
                                    formdata.append('tache', this.tache['id'])
                                    formdata.append('panne', null)
                                    formdata.append('duree', this.duree)
                                    formdata.append('niveauCharge', this.niveauCharge)
                                    formdata.append('horametre', this.horametre)
                                    formdata.append('idModif', this.idModif)
                                    formdata.append('photo', this.blob2)
                                    formdata.append('miseEnCharge', this.miseEnCharge)
                                    formdata.append('miseANiveau', this.miseANiveau)

                                    var requestOptions = {
                                        method: 'POST',
                                        headers: myHeaders,
                                        body: formdata,
                                        redirect: 'follow'
                                    };

                                    fetch(this.racine + this.site + 'api/save_operation', requestOptions)
                                        .then(response => response.json())
                                        .then(json => {

                                            console.log(json);
                                            if (json['msg'] != "") {
                                                this.errors2.push("Un problème inconnu s'est produit.")
                                                this.popup()
                                            }
                                            else if (json['valide'] > 0) {
                                                this.msgs2.push("Ajout de l'entretien effectué.")
                                                this.popup()
                                                setTimeout(() => {//on laisse le message quelques instants
                                                    this.$emit('returnMaintenanceApresValide')
                                                }, 2000)

                                            }
                                            else {
                                                this.errors2.push("Un problème inconnu s'est produit.")
                                                this.popup()
                                            }
                                        })

                                }
                            })
                    }
                    else {
                        this.popup()
                    }


                },
                popup() {
                    this.$bvModal.show('modalInfo')
                    setTimeout(() => {//on laisse le message quelques instants
                        this.$bvModal.hide('modalInfo')
                        this.errors2 = []
                        this.msgs2 = []
                    }, 2000)
                },
                getLastHorametre() {
                    fetch(this.racine + this.site + 'api/get_last_operation/' + this.machine['id'], {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {

                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.lastHorametre = json['horametre']
                                console.log(this.digits_count(this.lastHorametre))
                                this.nbrChiffreLastHorametre = this.digits_count(this.lastHorametre)
                            }
                        })
                    })
                },
                getLastTache() {
                    fetch(this.racine + this.site + 'api/get_last_tache/' + this.machine['id'] + '/'+this.tache.id, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {

                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.nbrJourLastTache = json['nbrJour']
                                this.dateLastTache = json['date']
                                if(this.nbrJourLastTache>6)
                                {
                                    this.$bvModal.show('modalLastTache')
                                }
                            }
                        })
                    })
                },
                digits_count(n) {
                    var count = 0;
                    if (n >= 1) ++count;

                    while (n / 10 >= 1) {
                        n /= 10;
                        ++count;
                    }

                    return count;
                },
                getMiseANiveauObligatoire() {
                    fetch(this.racine + this.site + 'api/get_refaire_niveau/' + this.machine.id, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {

                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.miseANiveauObligatoire = json['miseANiveau']
                            }
                        })
                    })
                },
                returnPicture(e) {
                    console.log("picture")
                    console.log(e)
                    this.blob2 = e[0]
                    this.dataUrl2 = e[1]
                },
                returnPictureNav(e) {
                    console.log("picture")
                    console.log(e)
                    this.blob2 = e[0]
                    this.dataUrl2 = e[1]
                },
                ifModif() {
                    if (this.idModif != null) {
                        fetch(this.racine + this.site + 'api/operations/' + this.idModif, {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.token
                            },
                        }).then(response => {

                            console.log(response)
                            response.json().then(json => {
                                if (json != undefined) {
                                    console.log(json)
                                    this.duree = json['duree']
                                    this.niveauCharge = json['niveauCharge']
                                    this.horametre = json['horametre']
                                    this.miseANiveau = json['miseANiveau']
                                    this.miseEnCharge = json['miseEnCharge']
                                    this.tache = json['tache']
                                    this.machine = json['machine']
                                    fetch(this.racine + this.site + 'api/get_photo_stat/' + this.idModif + '/operation', {
                                        method: 'GET',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': 'Bearer ' + this.token
                                        },
                                    }).then(response => {
                                        console.log(response)
                                        response.json().then(json => {
                                            if (json != undefined) {
                                                console.log(json)
                                                this.image = json['img']
                                            }
                                        })
                                    })
                                }
                            })
                        })
                    }
                },
                deletePictureFinal() {
                    if (this.dataUrl2 != null) {
                        this.dataUrl2 = null
                        this.blob2 = null
                    }
                    else if (this.image != null && this.idModif != null) {
                        fetch(this.racine + this.site + 'api/delete_photo/' + this.idModif + '/operation', {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.token
                            },
                        }).then(response => {
                            console.log(response)
                            response.json().then(json => {
                                if (json != undefined) {
                                    console.log(json)
                                    this.image = json['img']
                                }
                            })
                        })
                    }
                },
                deletePicture() {
                    this.$bvModal.msgBoxConfirm("Voulez vous supprimer cette image ?", {
                        title: 'Confirmation',
                        size: 'lg',
                        buttonSize: 'lg',
                        okVariant: 'danger',
                        okTitle: 'Oui',
                        cancelTitle: 'Non',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                        noFade: true
                    })
                        .then(value => {
                            if (value == true) {
                                this.deletePictureFinal()
                            }
                        })
                },
                deleteOperation() {
                    this.$bvModal.msgBoxConfirm("Voulez vous supprimer cet entretien ?", {
                        title: 'Confirmation',
                        size: 'lg',
                        buttonSize: 'lg',
                        okVariant: 'danger',
                        okTitle: 'Oui',
                        cancelTitle: 'Non',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true,
                        noFade: true
                    })
                        .then(value => {
                            if (value == true) {

                                fetch(this.racine + this.site + 'api/operations/' + this.idModif, {
                                    method: 'DELETE',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': 'Bearer ' + this.token
                                    },
                                }).then(response => {
                                    console.log(response)
                                    if (response.status == 204) {
                                        /*this.msgs2.push("La suppression a bien été effectué.")
                                        this.popup()*/
                                        this.deletePictureFinal()

                                        setTimeout(() => {//on laisse le message quelques instants
                                            this.$emit('returnMaintenanceApresValide')
                                        }, 1000)

                                    }
                                })

                            }
                        })
                },
                returnAMaintenance()
                {
                    this.$emit('returnMaintenance')
                },
                lireImg() {

                    var self = this
                    console.log(navigator.camera)
                    if (navigator.camera) {

                        navigator.camera.getPicture(result => {
                            console.log("cam")
                            console.log(Tesseract)

                            var blob3 = self.getBlob(result, 'jpeg', 512)
                            Tesseract.recognize(blob3, 'eng')

                                .then(function (result2) {
                                    console.log(result2['data'])
                                    console.log(result2['data']['text'])
                                    var text = result2['data']['text']
                                    self.horametre = text.replace(/\D/g,'')
                                    //alert(self.textImg+' '+self.textImg.replace(/\D/g,''))
                                })
                        }, this.onFail, {
                            quality: 30, sourceType: navigator.camera.PictureSourceType.CAMERA,
                            destinationType: navigator.camera.DestinationType.DATA_URL,
                            encodingType: navigator.camera.EncodingType.JPEG,
                            correctOrientation: true
                        });
                        console.log('2')
                    } else {
                        // If the navigator.camera is not available display generic error to the user.

                        console.log('3')
                    }

                },
                extractNumberFromString(str) {
                    var matches = str.match(/(\d+)/);

                    if (matches) {
                        return matches
                    }
                    else
                    {
                        return null
                    }
                },
                getBlob(b64Data, contentType, sliceSize) {
                    contentType = contentType || '';
                    sliceSize = sliceSize || 512;

                    let byteCharacters = window.atob(b64Data);
                    let byteArrays = [];

                    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                        let slice = byteCharacters.slice(offset, offset + sliceSize);

                        let byteNumbers = new Array(slice.length);
                        for (let i = 0; i < slice.length; i++) {
                            byteNumbers[i] = slice.charCodeAt(i);
                        }

                        let byteArray = new Uint8Array(byteNumbers);

                        byteArrays.push(byteArray);
                    }

                    let blob = new Blob(byteArrays, {type: contentType});
                    return blob;
                },
            },
        mounted() {
            this.getLastHorametre()
            this.getLastTache()
            this.getMiseANiveauObligatoire()
        },
        created() {
            this.ifModif()
        },
        components: {
            PictureNav,
            Picture,
        }
    }
</script>

<style scoped>

</style>